import { useAtomValueRawSync } from 'jotai';
import { useEffect } from 'react';

import { shellLocationAtom } from '@/state/ui/shellLocationAtoms';
import { focusedIdAtom } from '@/state/ui/shellRecordAtoms';
import { writeSavedFocus } from '@/state/ui/viewFocusStorage';

/** Keeps the panel in front with the view that the history entry shows. */
export function useHistoryFocus(): void {
    const { search } = useAtomValueRawSync(shellLocationAtom);
    const focusedId = useAtomValueRawSync(focusedIdAtom);

    // Recorded once the task settles: a click that moves the focus and then navigates moves it
    // for the view it opens, not for the one it leaves.
    useEffect((): (() => void) => {
        const timer = setTimeout((): void => {
            writeSavedFocus(search, focusedId);
        }, 0);
        return (): void => clearTimeout(timer);
    }, [search, focusedId]);
}
